export const introducerQuestions: Record<string, any> = {
  hasIntroducer: {
    labelKey: 'applicationForm.INTRODUCER.hasIntroducer.label',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  firstName: {
    labelKey: 'applicationForm.INTRODUCER.firstName.label',
  },
  lastName: {
    labelKey: 'applicationForm.INTRODUCER.lastName.label',
  },
  email: {
    labelKey: 'applicationForm.INTRODUCER.email.label',
  },
  phoneNumber: {
    labelKey: 'applicationForm.INTRODUCER.phoneNumber.label',
  },
};
